<template>
  <h1>{{$route.params.post_id}}</h1>
</template>

<script>
export default {

};
</script>

<style>

</style>
